// Сотрудники
import { create } from 'zustand';
import {
	getStaff,
	updateStaff,
	getAdminStaff,
	getStaffByGroup,
	getCallcenterStaff,
	getDepartmentStaff,
	getSpecialistStaff,
	checkBookingExists,
	getOutstaffManagers,
	getStaffByGroupSingle,
	getOutstaffByDepartment,
	getStaffByCallcenter
} from 'services';

export const useStaffStore = create((set) => ({
	staffList: [],
	departmentStaff: [],
	workScheduleStaffList: [], // сотрудники в графике рабочего времени
	specialistStaffList: [], // специалисты компании
	adminStaffList: [], // администраторы компании
	managersList: [],
	staffCallcenter: [], // сотрудники Callcenter
	singleStaff: {}, // сотрудник группы sanatera
	loading: false,
	loadingStaff: false,
	loadingCallcenter: false,
	bookingsExists: false, // свободное время специалиста
	// Получение сотрудников (пока не используется)
	getStaff: async () => {
		set({ loading: true });
		const staffList = await getStaff();
		set({ staffList, loading: false });
	},
	getDepartmentStaff: async (departmentId) => {
		set({ loading: true });
		const departmentStaff = await getDepartmentStaff(departmentId);
		set({ departmentStaff, loading: false });
	},
	// Получение специалистов компании
	getSpecialistStaff: async (departmentId) => {
		set({ loading: true });
		const workScheduleStaffList = await getSpecialistStaff(departmentId);
		set({ workScheduleStaffList, loading: false });
	},
	// Получение администраторов компании
	getAdminStaff: async (departmentId) => {
		set({ loading: true });
		const workScheduleStaffList = await getAdminStaff(departmentId);
		set({ workScheduleStaffList, loading: false });
	},
	// Получение сотрудников Callcenter для графика рабочего времени
	getCallcenterStaff: async () => {
		set({ loading: true });
		const workScheduleStaffList = await getCallcenterStaff();
		set({ workScheduleStaffList, loading: false });
	},
	// Получение сотрудников по группе sanatera и департаменту
	getStaffByGroup: async (departmentId) => {
		set({ loadingStaff: true });
		const staffList = await getStaffByGroup(departmentId);
		set({ staffList, loadingStaff: false });
	},
	// Получение сотрудников Callcenter для учета рабочего времени
	getStaffByCallcenter: async () => {
		set({ loadingCallcenter: true });
		const staffCallcenter = await getStaffByCallcenter();
		set({ staffCallcenter, loadingCallcenter: false });
	},
	getOutstaffByDepartment: async (departmentId) => {
		const departmentStaff = await getOutstaffByDepartment(departmentId);
		set({ departmentStaff });
	},
	// Получение менеджеров аутстафф
	getOutstaffManagers: async (departmentId) => {
		const managersList = await getOutstaffManagers(departmentId);
		set({ managersList });
	},
	// Получение сотрудника по группе sanatera
	getStaffByGroupSingle: async (id) => {
		const singleStaff = await getStaffByGroupSingle(id);
		set({ singleStaff });
	},
	updateStaff: async (staff) => {
		await updateStaff(staff);
	},
	// Проверка свободного времени специалиста
	checkBookingExists: async (data) => {
		const bookingsExists = await checkBookingExists(data);
		set({ bookingsExists, loading: false });
	}
}))